import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const SingularityAndPoles = () => (
  <QPhototModuleSubtopic
    title="Singularity and Poles"
    videos={[
      "https://www.youtube.com/embed/G1Wc5gGAZ8A",
      "https://www.youtube.com/embed/SjKwEox2-W8",
      "https://www.youtube.com/embed/aWY2xmUerys",
      "https://www.youtube.com/embed/3qPuKs71ELc"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_33.png"},
        {image:"/cvla_34.png"},
    ]}
    exampleVideos={[]}
  />
);

export default SingularityAndPoles;
